<template>
  <v-container class="top-spacer" style="padding:0">
    <div class="component-title">Notícias</div>
    <v-row>
      <v-col cols="12">
        <v-row v-if="news.length > 0">
          <v-col
            class="news-col"
            v-for="(item, index) in news"
            :key="'news-' + index"
          >
            <NewsCard
              :news="item"
              @open-dialog="
                selectedNews = item;
                showNewsDetails = true;
              "
            ></NewsCard>
          </v-col>
        </v-row>
        <v-card v-else class="empty-state">
          Não existem notícias de momento
        </v-card>
      </v-col>
    </v-row>
    <!-- PAGINATION -->
    <v-row class="pagination">
      <v-col>
        <v-pagination
          v-model="page"
          :length="Math.ceil(this.items.length / 8)"
          :total-visible="3"
          color="#D8E0E6"
          style="float: left;"
        ></v-pagination>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showNewsDetails"
      content-class="news-dialog"
      transition="slide-x-reverse-transition"
    >
      <NewsDetails
        @close-dialog="showNewsDetails = false"
        :newsDetails="selectedNews"
      ></NewsDetails>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.empty-state {
  width: 280px;
  height: 295px;
  text-align: center;
  vertical-align: middle;
  line-height: 295px !important;
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  color: #9aabb8;
}
.news-col {
  flex: 0 0 25%;
  max-width: 25%;
}
@media only screen and (max-width: 1024px) {
  .news-col {
    flex: 0 0 33%;
    max-width: 33%;
  }
}
@media only screen and (max-width: 768px) {
  .news-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media only screen and (max-width: 480px) {
  .news-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>

<script>
import NewsCard from "@/components/NewsCard.vue";
import NewsDetails from "@/components/NewsDetails.vue";

import ApiService from "@/services/api.service";

export default {
  name: "Noticias",
  components: {
    NewsCard,
    NewsDetails
  },
  data: () => ({
    page: 1,
    news: [],
    showNewsDetails: false,
    selectedNews: {}
  }),
  created() {
    this.getNews(0, 8);
  },
  methods: {
    getNews(page, size) {
      this.loading = true;
      ApiService.getNews("", page, size).then(
        response => {
          const data = response.data;
          this.news = data.news;
          this.totalPages = data.totalPages;
          this.loading = false;
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    }
  },
  computed: {
    items() {
      const list = Array.from({ length: 20 }, (k, v) => {
        return {
          avatar: "news_avatar.jpg",
          title:
            "Tal pai, tal filho: Estatísticas de Cristianinho são de outro planeta",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Risus nullam eget felis eget nunc lobortis. Massa tincidunt dui ut ornare lectus sit amet est placerat. Metus vulputate eu scelerisque felis imperdiet proin fermentum. Mattis vulputate enim nulla aliquet porttitor lacus luctus accumsan. Id diam maecenas ultricies mi eget. Congue eu consequat ac felis donec et odio. Feugiat in ante metus dictum at tempor. Mauris pellentesque pulvinar pellentesque habitant morbi tristique senectus. Odio facilisis mauris sit amet massa vitae tortor condimentum lacinia. Magna sit amet purus gravida quis blandit turpis cursus in. Consectetur purus ut faucibus pulvinar elementum integer enim. <br/><br/>Lectus mauris ultrices eros in cursus turpis massa tincidunt dui. Nibh sit amet commodo nulla facilisi nullam vehicula ipsum. Faucibus pulvinar elementum integer enim neque volutpat ac tincidunt. Et leo duis ut diam quam nulla.",
          date: "19h45 . 25 Ago 2019"
        };
      });

      return list;
    },
    newsList() {
      console.log(this.items);
      return this.items.slice((this.page - 1) * 8, this.page * 8);
    }
  }
};
</script>
